import React, { useState } from 'react';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';

const Input = ({
  variant = 'standard',
  label = '',
  helperText,
  error = false,
  width = '200px',
}) => {
  // variant are of types: outlined, filled, standard
  const [value, setValue] = useState('');
  return (
    <FormControl variant="standard">
      <TextField
        label={label}
        variant={variant}
        error={error}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        sx={{ width }}
      />
      {helperText && <FormHelperText error={error}>{helperText}</FormHelperText>}
    </FormControl>
  );
};

export default Input;
